import { createRoot } from 'react-dom/client';
import React from 'react';
import { UserCreatedChallengeDialog } from './UserCreatedChallengeDialog';

let root: ReturnType<typeof createRoot> | null = null;

export function openUserChallengeDialog(challengeId?: string) {
  let container = document.querySelector('#user-challenge-dialog-root');

  if (!container) {
    container = document.createElement('div');
    container.id = 'user-challenge-dialog-root';
    document.body.appendChild(container);
  }

  const handleClose = () => {
    if (root) {
      root.render(
        React.createElement(UserCreatedChallengeDialog, {
          isOpen: false,
          onClose: handleClose,
          challengeId: undefined
        })
      );
    }
  };

  root = createRoot(container);
  root.render(
    React.createElement(UserCreatedChallengeDialog, {
      isOpen: true,
      onClose: handleClose,
      challengeId
    })
  );
}
